import { Answers } from './../views/components/check/OhatResultGraph';
import { OhatScore } from '@models/ohatScore';
import { OhatStatus } from '../constants/status';
import { format, getNowLabel } from './date';

// export const initAnswers: Answers = {
//   score: {
//     0: -1,
//     1: -1,
//     2: -1,
//     3: -1,
//     4: -1,
//     5: -1,
//     6: -1,
//     7: -1,
//   },
//   evaluatedAt: getNowLabel(),
// };

export const getInitAnswers = (): Answers => {
  return {
    score: {
      0: -1,
      1: -1,
      2: -1,
      3: -1,
      4: -1,
      5: -1,
      6: -1,
      7: -1,
    },
    memos: {},
    evaluatedAt: getNowLabel(),
  };
};

export const extractAnswers = (score: OhatScore): Answers => {
  return {
    score: {
      0: score.q1,
      1: score.q2,
      2: score.q3,
      3: score.q4,
      4: score.q5,
      5: score.q6,
      6: score.q7,
      7: score.q8,
    },
    memos: {
      0: score.q1Memo ?? '',
      1: score.q2Memo ?? '',
      2: score.q3Memo ?? '',
      3: score.q4Memo ?? '',
      4: score.q5Memo ?? '',
      5: score.q6Memo ?? '',
      6: score.q7Memo ?? '',
      7: score.q8Memo ?? '',
    },
    evaluatedAt: format(score.evaluatedAt, 'YYYY/MM/DD'),
    // 評価者は未記録（過去データ）の場合がある
    evaluatorName: score.evaluatorName ?? undefined,
  };
};

/** 合計スコアの算出。未回答（-1）を含む場合でもマイナスにはしない。 */
const sumScores = (values: number[]): number => {
  const total = values.reduce((a, v) => a + v, 0);
  return total > 0 ? total : 0;
};

/** q1〜q8の合計スコア。未回答（-1）を含む場合でもマイナスにはしない。 */
export const getTotalScore = (answers: Answers): number => {
  return sumScores(Object.values(answers.score));
};

/** 合計スコアの算出に必要な項目だけを持つ評価。 */
export type ScoredItems = Pick<
  OhatScore,
  'q1' | 'q2' | 'q3' | 'q4' | 'q5' | 'q6' | 'q7' | 'q8'
>;

/**
 * 評価レコード（q1〜q8）の合計スコア。
 * Answers 形式に変換していない一覧・CSVなどから使う。
 */
export const getOhatScoreTotal = (score: ScoredItems): number => {
  return sumScores([
    score.q1,
    score.q2,
    score.q3,
    score.q4,
    score.q5,
    score.q6,
    score.q7,
    score.q8,
  ]);
};

export const getScoreTableRow = (key: string, answers: Answers) => {
  return {
    'key': key,
    '0': OhatStatus.getByScore(answers.score[0])?.label,
    '1': OhatStatus.getByScore(answers.score[1])?.label,
    '2': OhatStatus.getByScore(answers.score[2])?.label,
    '3': OhatStatus.getByScore(answers.score[3])?.label,
    '4': OhatStatus.getByScore(answers.score[4])?.label,
    '5': OhatStatus.getByScore(answers.score[5])?.label,
    '6': OhatStatus.getByScore(answers.score[6])?.label,
    '7': OhatStatus.getByScore(answers.score[7])?.label,
  };
};

export const getScoreTableRowHalf1 = (key: string, answers: Answers) => {
  return {
    'key': key,
    '0': OhatStatus.getByScore(answers.score[0])?.label,
    '1': OhatStatus.getByScore(answers.score[1])?.label,
    '2': OhatStatus.getByScore(answers.score[2])?.label,
    '3': OhatStatus.getByScore(answers.score[3])?.label,
  };
};

export const getScoreTableRowHalf2 = (key: string, answers: Answers) => {
  return {
    'key': key,
    '0': OhatStatus.getByScore(answers.score[4])?.label,
    '1': OhatStatus.getByScore(answers.score[5])?.label,
    '2': OhatStatus.getByScore(answers.score[6])?.label,
    '3': OhatStatus.getByScore(answers.score[7])?.label,
  };
};

export const defaultScoreTableRow = (key: string) => {
  return {
    'key': key,
    '0': 0,
    '1': 0,
    '2': 0,
    '3': 0,
    '4': 0,
    '5': 0,
    '6': 0,
    '7': 0,
  };
};
